'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var STYLE_DEFAULTS = {
  height: 64
};

function getStyles() {
  var conf = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var height = (conf.height || STYLE_DEFAULTS.height) + 'px';
  return {
    header: {
      position: 'fixed',
      top: '0',
      left: '0',
      width: '100%',
      height: height,
      zIndex: '1000'
    },
    main: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      paddingTop: height,
      boxSizing: 'border-box'
    }
  };
}

var AppWrapper = function (_Component) {
  _inherits(AppWrapper, _Component);

  function AppWrapper() {
    _classCallCheck(this, AppWrapper);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(AppWrapper).apply(this, arguments));
  }

  _createClass(AppWrapper, [{
    key: 'render',
    value: function render() {

      var styles = getStyles(this.props);

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'header',
          { style: styles.header },
          this.props.appbar
        ),
        _react2.default.createElement(
          'main',
          { style: styles.main },
          this.props.children
        )
      );
    }
  }]);

  return AppWrapper;
}(_react.Component);

exports.default = AppWrapper;


/** WEBPACK FOOTER **
 ** ../kettle-ui/lib/AppWrapper.js
 **/